import { useTranslation } from 'react-i18next';
import { StyledCartCheckoutButton } from './cart.styled';

interface CartCheckoutButtonProps {
  onClick: () => void;
  disabled: boolean;
}

export const CartCheckoutButton = ({
  onClick,
  disabled,
}: CartCheckoutButtonProps) => {
  const { t } = useTranslation('hubCommon');

  return (
    <StyledCartCheckoutButton
      variant="accent"
      size="sm"
      onClick={onClick}
      disabled={disabled}
    >
      {t('cart.checkoutNow')}
    </StyledCartCheckoutButton>
  );
};
